import React from "react";
import AppBar from "@material-ui/core/AppBar";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import MailIcon from "@material-ui/icons/Mail";
import { Link } from "react-router-dom";
import { Link as LinkToAnchor } from "react-scroll";
import Logo from "../../assets/logo.png";

const useStyles = makeStyles((theme) => ({
  root: {
    // flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    marginLeft: theme.spacing(6),
  },
  appBar: {
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    position: "fixed",
    boxShadow: "none", // <--- remove it if you want 3D effect
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  fontColorChange: {
    color: "black",
  },
  logo: {
    height: "100px",
  },
}));

export default function TopAppBar(props) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Typography
            variant="h6"
            className={`${classes.title} ${classes.sectionDesktop}`}
          >
            <Link style={{ textDecoration: "none", color: "white" }} to="/">
              <img className={classes.logo} src={Logo} alt="logo" />
            </Link>
          </Typography>
          <div className={classes.sectionMobile} style={{ flexGrow: 1 }}></div>
          <div style={{ display: "flex" }}>
            <LinkToAnchor
              to="gallery"
              smooth={true}
              style={{ cursor: "pointer", marginRight: "1em" }}
            >
              PROJECTS
            </LinkToAnchor>
            <LinkToAnchor
              to="contact"
              smooth={true}
              style={{ cursor: "pointer", marginRight: "1em" }}
            >
              <MailIcon />
            </LinkToAnchor>
          </div>
          <div></div>
        </Toolbar>
      </AppBar>
    </div>
  );
}
